import BaseService from "../base";
import ChangePOStepService from "./changePOStepService";

class ChangePOService extends BaseService {
  getProcedureOwnerStepItem = (
    para: any,
    success: any,
    error: any,
    interfaceList: any,
    mergePayloadMap: any
  ) => {
    ChangePOStepService.getStepData(para, success, error, interfaceList, mergePayloadMap);
  };

  changeProcedureOwnerTriggerStepAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("changeProcedureOwnerTriggerStepAction", para, success, error);
  };

  checkPoIsExisted = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkPoIsExisted", para, success, error);
  };

  getFlowStepData = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getFlowStepData", para, success, error);
  };
}

const changePOService = new ChangePOService();

export default changePOService;
